import React, { useState } from "react";

const StarRating = ({ maxRating = 5, onChange, value, disabled = false }) => {
  const [rating, setRating] = useState(value || 0);

  const handleClick = (index) => {
    if (disabled) return; // Prevent changes when disabled
    setRating(index + 1);
    onChange && onChange(index + 1);
  };

  return (
    <div>
      {[...Array(maxRating)].map((_, i) => (
        <i
          key={i}
          onClick={() => handleClick(i)}
          className={`fa-star px-2 ${
            i < rating ? "fa-solid text-warning" : "fa-regular"
          }`}
          style={{
            cursor: disabled ? "default" : "pointer", // Change cursor based on disabled state
            fontSize: "1.2rem",
          }}
        ></i>
      ))}
    </div>
  );
};

export default StarRating;